module.exports = __webpack_public_path__ + "media/images/logo-9eaffb97.svg";